import React, {Component} from 'react';
import { 
    Route,
    Router,
    Switch
} from 'react-router-dom';
import * as Page from './pages';
import * as Path from './constants';
import PrivateRoute from './privateRoute';
import history from './history';

class Routes extends Component {
    render(){
        return (
            <Router history={history} basename={Path.ROOT_URL}>
                <Switch>
                    {/* Main Routes */}
                    <Route exact path={Path.LOGIN} component={(Page.Login)}/>
                    <PrivateRoute path={["",Path.MAIN]} component={(Page.Main)}/>
                </Switch>
            </Router>
        );
    }
};

export default Routes;